import { render, staticRenderFns } from "./IdentificationSignalant.vue?vue&type=template&id=5664346e"
import script from "./IdentificationSignalant.vue?vue&type=script&lang=js"
export * from "./IdentificationSignalant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports